import { render } from "./RDFCharts.vue?vue&type=template&id=68c40790&scoped=true"
import script from "./RDFCharts.vue?vue&type=script&lang=js"
export * from "./RDFCharts.vue?vue&type=script&lang=js"

import "./RDFCharts.vue?vue&type=style&index=0&id=68c40790&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c40790"]])

export default __exports__